import { useQuery } from '@tanstack/react-query';
import { dashboardService } from '../end-points/dashboard';

export function useProponenteDashboard() {
  return useQuery({
    queryKey: ['dashboard', 'proponente'],
    queryFn: async () => {
      const data = await dashboardService.getProponenteDashboard();

      if (!data) {
        throw new Error('No data received from server');
      }
      return data;
    },
    refetchInterval: 5 * 60 * 1000, // Auto-refresh every 5 minutes
    staleTime: 2 * 60 * 1000, // Consider data stale after 2 minutes
    retry: 1, // Only retry once on failure
  });
}

export function useServiceProviderDashboard() {
  return useQuery({
    queryKey: ['dashboard', 'service-provider'],
    queryFn: async () => {
      const data = await dashboardService.getServiceProviderDashboard();
      // Ensure we always return data, never undefined
      if (!data) {
        throw new Error('No data received from server');
      }
      return data;
    },
    refetchInterval: 5 * 60 * 1000, // Auto-refresh every 5 minutes
    staleTime: 2 * 60 * 1000, // Consider data stale after 2 minutes
    retry: 1, // Only retry once on failure
  });
}
